/**
 * Partner template regExp.
 */
export const PARTNER_TEMPLATE_REG_EXP = /\${partner}/gm;

/**
 * Interpolate partner template with real human readable partner name.
 */
export const interpolatePartner = (string: string, partner: string) =>
    string.replace(PARTNER_TEMPLATE_REG_EXP, partner);
